let scrollLockCount = 0;
let lockedScrollY = 0;

export function lockScroll() {
  if (typeof document === "undefined") {
    return;
  }

  scrollLockCount += 1;

  if (scrollLockCount > 1) {
    return;
  }

  lockedScrollY = window.scrollY || window.pageYOffset || 0;

  document.body.style.position = "fixed";
  document.body.style.top = `-${lockedScrollY}px`;
  document.body.style.left = "0";
  document.body.style.right = "0";
  document.body.style.width = "100%";
  document.body.style.overflow = "hidden";
  document.documentElement.style.overflow = "hidden";
}

export function unlockScroll() {
  if (typeof document === "undefined" || scrollLockCount === 0) {
    return;
  }

  scrollLockCount -= 1;

  if (scrollLockCount > 0) {
    return;
  }

  document.body.style.position = "";
  document.body.style.top = "";
  document.body.style.left = "";
  document.body.style.right = "";
  document.body.style.width = "";
  document.body.style.overflow = "";
  document.documentElement.style.overflow = "";

  window.scrollTo(0, lockedScrollY);
}
